export const version = "1.0.2-daily-20260401-0";
export const channel = "daily";
export const gitcommit = "20b9412df";
